import { useEffect, useState } from 'react';
import { Col, Space } from 'antd';
import Title from 'antd/lib/typography/Title';
import Paragraph from 'antd/lib/typography/Paragraph';
import PageHelp from '../../Components/Page/PageHelp';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useParams } from "react-router-dom";
import { EventService } from '../../Services/EventService';
import { AuthProvider } from '../../Providers/authProvider';
import { InviteService } from '../../Services/InviteService';
import { TextService } from '../../Services/TextService';
import { BookyTitleWithIcon } from '../../Components/Forms/TitleWithIcon';
import { InviteList } from '../../Components/EventDetails/InviteList';
import { ReminderForm } from '../../Components/EventDetails/ReminderForm';
import LayoutLeftMenu from '../../Components/Layout/LayoutLeftMenu';
import { EventHeader } from '../../Components/EventDetails/EventHeader';
import LeftMenuEventDetails from './LeftMenuEventDetails';

/**
 * Who has been invited and whether they have replied, and the reminder to those who haven't. Kept apart
 * from Status & Svar, which shows the replies.
 */
const MyEventDetailsInvites = () => {
  const [event, setEvent] = useState({} as any);
  const [invites, setInvites] = useState([] as any[]);
  const GetText = TextService.GetText;
  let params = useParams();

  const loadInvites = (eventUniqueId: string) => {
    InviteService.GetInvites(eventUniqueId).then(inviteResult => {
      setInvites(inviteResult.invites ?? []);
    });
  }

  const loadEvent = (id: string) => {
    EventService.GetEventDetails(id).then(result => {
      setEvent(result);
      loadInvites(result.eventUniqueId ? result.eventUniqueId : "");
    });
  };

  useEffect(() => {
    AuthProvider().ValidateUserLogin();
    if (params.id != null) {
      loadEvent(params.id);
    }
  }, [params])

  const invitesNoReply: string[] = invites.filter((invite: any) => invite.replyId == 0).map((invite: any) => invite.email);

  return <LayoutLeftMenu hasTitleTop={true} header={<EventHeader event={event} />} fullpageMain={true} title={GetText("EventInvites_Title")} menu={<LeftMenuEventDetails selected={"invites"} membersOnly={event.membersOnly} />}>
    <Col xs={24} md={18} lg={16}>
      <Col className='bookyBox event-page-box'>
        {/* The same heading as the menu item, like Status & Svar. Invites are sent from the menu, which the help says. */}
        <Space style={{ width: '100%', justifyContent: 'left', margin: 0 }}>
          <Title style={{ marginTop: 0 }}>{GetText("EventInvites_Title")}</Title>
          <PageHelp>{GetText("EventInvites_HowItWorks").split("\n\n").map((text, i) => <Paragraph key={i}>{text}</Paragraph>)}</PageHelp>
        </Space>
        {invites.length > 0 ?
          <Paragraph type="secondary" style={{ textAlign: "left" }}>
            {invites.length} {GetText("EventDetails_InvitesSent")} {invites.length - invitesNoReply.length} {GetText("EventDetails_InvitesHaveReplied")}
          </Paragraph> : null}
        <InviteList loadEvent={loadEvent} event={event} invites={invites}></InviteList>
      </Col>

      <Col className='bookyBox event-page-box' style={{ marginTop: "20px" }}>
        <BookyTitleWithIcon text={GetText("MyEventDetails_Reminders")}><ClockCircleOutlined /></BookyTitleWithIcon>
        <ReminderForm invitesNoReply={invitesNoReply} event={event} invites={invites}></ReminderForm>
      </Col>
    </Col>
  </LayoutLeftMenu>
};

export default MyEventDetailsInvites;
